import { Request } from '../../httpClient/serverApi/requests/Request';
import { IResult } from '../../httpClient/serverApi/types/IResponse';

export interface ReevaluateUserIdentityConflictsParams {
    ids: string[];
}

export class ReevaluateUserIdentityConflictsRequest extends Request<ReevaluateUserIdentityConflictsParams, IResult> {
  constructor(params: ReevaluateUserIdentityConflictsParams) {
    super('reevaluateUserIdentityConflicts', params);
  }
}
